(() => {
  if (window.calvaniConfidenceInitialized) return;
  window.calvaniConfidenceInitialized = true;
  let opener;
  const bindDialog = (dialog) => {
    if (!dialog || dialog.dataset.calvaniBound) return;
    dialog.dataset.calvaniBound = 'true';
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (!first) return;
      if (event.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    });
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('calvani-confidence-is-open');
      if (opener?.isConnected) opener.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-calvani-confidence-open]');
    if (trigger) {
      const dialog = document.getElementById('calvani-confidence-dialog');
      if (!dialog || dialog.open) return;
      bindDialog(dialog);
      opener = trigger;
      dialog.showModal();
      document.documentElement.classList.add('calvani-confidence-is-open');
    }
    if (event.target.closest('[data-calvani-confidence-close]')) document.getElementById('calvani-confidence-dialog')?.close();
  });
  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector('#calvani-confidence-dialog')) document.documentElement.classList.remove('calvani-confidence-is-open');
  });
})();
